// Table whitelist -- must match API route's allowed tables.
// All tables here have a deleted_at TIMESTAMPTZ column (verified via migrations).
export const SOFT_DELETE_TABLES = ['artworks', 'orders', 'sticker_orders', 'site_content']

/**
 * Client-side: call DELETE on the row, return { table, id } for undo.
 * The DELETE endpoint sets deleted_at = now() (soft delete).
 * @param {{ table: string, id: string, getAdminHeaders: () => object }} opts
 */
export async function softDelete({ table, id, getAdminHeaders }) {
  if (!SOFT_DELETE_TABLES.includes(table)) {
    throw new Error(`Table ${table} not in soft-delete whitelist`)
  }
  const res = await fetch(`/api/admin/${table}?id=${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: getAdminHeaders(),
  })
  if (!res.ok) throw new Error(`Soft delete failed: ${res.status}`)
  return { table, id }
}

/**
 * Client-side: call POST /api/admin/undo to restore a soft-deleted row.
 * @param {{ table: string, id: string, getAdminHeaders: () => object }} opts
 */
export async function undoSoftDelete({ table, id, getAdminHeaders }) {
  const res = await fetch('/api/admin/undo', {
    method: 'POST',
    headers: { ...getAdminHeaders(), 'Content-Type': 'application/json' },
    body: JSON.stringify({ table, id }),
  })
  if (!res.ok) throw new Error(`Undo failed: ${res.status}`)
  return res.json()
}
